<template>
    <div class="blog-home">
      <article class="about  active" data-page="about">
      <header>
          <h2 class="h2 article-title">All Books</h2>
      </header>
      <BookPost 
        v-for="book in books" 
        :key="book.id" 
        :book="book"
        style="border-style: solid;background: var(--border-gradient-onyx);border-radius: 5px;"
      />
    </article>
    </div>
  </template>
  
  <script>
  import BookPost from '@/components/BookPost.vue'
  import books from '@/data/books'
  
  export default {
    name: 'BlogAllBooksPage',
    components: {
      BookPost
    },
    data() {
      return {
        books
      }
    }
  }
  </script>
  
  <!-- // Basic Styling (you can move this to a separate CSS file) -->
  <style>
  .book-post {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    border-style: inset;
    margin-bottom: 20px;
  }
  
  .book-cover {
    max-width: 100px;
    height: auto;
    border-color: #ffc562;
    border-width: 2px;
    border-style: inset;
  }
  
  .author-image {
    width: 100px;
    height: auto;
    border-radius: 25%;
    border-color: #ffc562;
    border-width: 2px;
    border-style: inset;
  }
  
  .book-tags .tag {
    background-color: #f0f0f0;
    padding: 5px 10px;
    margin-right: 10px;
    border-radius: 15px;
  }
  </style>
  
  